import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { PartnerDigital } from 'Pages/smsExpansion'

export const partnerApi = {
	updateOne: async (id: number, data: PartnerDigital) => {
		const res = await axiosDS().patch<PartnerDigital>(`${urls.partner.index}/${id}`, { data })
		return res.data
	},
}
